import React from 'react';
import { CheckCircle, XCircle, AlertTriangle } from 'react-feather';

type NotificationType = 'success' | 'error' | 'warning';

interface InlineNotificationProps {
  type: NotificationType;
  title: string;
  message: string;
  className?: string;
}

const NotificationIcon = ({ type }: { type: NotificationType }) => {
  const iconProps = {
    size: 16,
    className: 'mr-2 mt-0.5 flex-shrink-0',
  };

  switch (type) {
    case 'success':
      return (
        <CheckCircle
          {...iconProps}
          className={`${iconProps.className} text-green-400`}
        />
      );
    case 'error':
      return (
        <XCircle
          {...iconProps}
          className={`${iconProps.className} text-red-400`}
        />
      );
    case 'warning':
      return (
        <AlertTriangle
          {...iconProps}
          className={`${iconProps.className} text-yellow-400`}
        />
      );
    default:
      return null;
  }
};

const getNotificationStyles = (type: NotificationType) => {
  const baseStyles = 'border rounded-md p-3 text-sm';

  switch (type) {
    case 'success':
      return `${baseStyles} bg-green-50 border-green-200 text-green-700`;
    case 'error':
      return `${baseStyles} bg-red-50 border-red-200 text-red-700`;
    case 'warning':
      return `${baseStyles} bg-yellow-50 border-yellow-200 text-yellow-700`;
    default:
      return baseStyles;
  }
};

export const InlineNotification = ({
  type,
  title,
  message,
  className = '',
}: InlineNotificationProps) => {
  return (
    <div className={`${getNotificationStyles(type)} ${className}`}>
      <div className="flex items-start">
        <NotificationIcon type={type} />
        <div>
          <div className="font-semibold">{title}</div>
          <div className="text-xs mt-1">{message}</div>
        </div>
      </div>
    </div>
  );
};

export default InlineNotification;
